import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import $ from 'jquery';
import 'fullcalendar';

import 'fullcalendar/dist/locale/pt-br';
import 'fullcalendar/dist/fullcalendar.css';
import './calendar.css';

import { fetchHolidays } from '../../store/actions/holiday';

class Calendar extends React.Component {
  componentDidMount() {
    $('#calendar').fullCalendar({
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,listMonth',
      },
      views: {
        month: {
          titleFormat: 'MMMM YYYY',
        },
      },
      aspectRatio: 2.6,
      fixedWeekCount: false,
      showNonCurrentDates: false,
      dayClick: (day) => {
        this.props.handleOpenModal('Cadastrar', day);
      },
      eventClick: (event) => {
        this.props.handleOpenModal('Excluir', event);
      },
      events: (start, end, timezone, callback) => {
        this.props
          .onFetchHolidays(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
          .then(() => {
            const events = [];
            this.props.holidays.forEach((holiday) => {
              events.push({
                id: holiday.id,
                title: holiday.description,
                start: holiday.dtRef.slice(0, 10),
                isNational: holiday.label === 'NACIONAL',
                nationalHoliday: holiday.isNational,
                location: {
                  city: holiday.city,
                  code: holiday.cod,
                  state: holiday.state,
                  uf: holiday.uf,
                },
                isAnual: holiday.isAnual,
                color: holiday.label === 'NACIONAL' ? '#30b299' : '#3b94db',
                className: 'fc-personal',
              });
            });
            callback(events);
          })
          .catch(error => error);
      },
    });
  }

  componentDidUpdate(nextProps) {
    if (JSON.stringify(nextProps.holidays) !== JSON.stringify(this.props.holidays)) {
      $('#calendar').fullCalendar('refetchEvents');
    }
  }

  render() {
    return <div id="calendar" />;
  }
}

const mapStateToProps = state => ({
  token: state.auth.token,
  holidays: state.holiday.holidays,
});

const mapDispatchToProps = dispatch => ({
  onFetchHolidays: (startDate, endDate) => dispatch(fetchHolidays(startDate, endDate)),
});

Calendar.propTypes = {
  handleOpenModal: PropTypes.func.isRequired,
  holidays: PropTypes.array.isRequired,
  onFetchHolidays: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
